import { ALL_SIGNAL_IDS, ALL_THEME_IDS } from './mockOnboardingCatalog';

/** Screener clause strings keyed by onboarding signal id (step 3). */
export const SIGNAL_SCREENER_QUERIES: Record<string, string> = {
  revenue_growth_yoy: 'revenue_growth_past_1_year_cagr > 15%',
  gross_margin: 'gross_profit_margin_ttm > 30%',
  operating_margin: 'operating_profit_margin_ttm > 5%',
  net_margin: 'net_profit_margin_ttm > 5%',
  free_cash_flow: 'free_cash_flow_ttm > 0',
  roe: 'return_on_equity_ttm > 10%',
  roa: 'return_on_assets_ttm > 3%',
  debt_to_equity: 'debt_to_equity_ratio_current < 1',
  eps_growth_yoy: 'eps_growth_past_1_year_cagr > 5%',
};

/** Screener clause strings keyed by onboarding theme id (step 3). Values match list_filter_values.json. */
export const THEME_SCREENER_QUERIES: Record<string, string> = {
  technology: 'sector = Technology',
  financial_services: 'sector = Financial Services',
  healthcare: 'sector = Healthcare',
  real_estate: 'sector = Real Estate',
  consumer_cyclical: 'sector = Consumer Cyclical',
  energy: 'sector = energy',
  industrials: 'sector = industrials',
  communication_services: 'sector = Communication Services',
  utilities: 'sector = utilities',
  basic_materials: 'sector = Basic Materials',
  consumer_defensive: 'sector = Consumer Defensive',
};

export function getSignalScreenerQuery(signalId: string): string | null {
  return SIGNAL_SCREENER_QUERIES[signalId] ?? null;
}

export function hasSignalScreenerQuery(signalId: string): boolean {
  return signalId in SIGNAL_SCREENER_QUERIES;
}

/** Build preferences list of screener clauses for currently selected signals. */
export function buildSignalQueriesPreference(signalIds: string[]): string[] {
  const queries: string[] = [];
  for (const signalId of signalIds) {
    const query = getSignalScreenerQuery(signalId);
    if (query) {
      queries.push(query);
    }
  }
  return queries;
}

export function getThemeScreenerQuery(themeId: string): string | null {
  return THEME_SCREENER_QUERIES[themeId] ?? null;
}

export function hasThemeScreenerQuery(themeId: string): boolean {
  return themeId in THEME_SCREENER_QUERIES;
}

/** Ensures every catalog signal has a screener mapping. */
export function assertAllSignalsMapped(): void {
  for (const signalId of ALL_SIGNAL_IDS) {
    if (!hasSignalScreenerQuery(signalId)) {
      throw new Error(`Missing screener query for onboarding signal: ${signalId}`);
    }
  }
}

/** Ensures every catalog theme has a screener mapping. */
export function assertAllThemesMapped(): void {
  for (const themeId of ALL_THEME_IDS) {
    if (!hasThemeScreenerQuery(themeId)) {
      throw new Error(`Missing screener query for onboarding theme: ${themeId}`);
    }
  }
}

assertAllSignalsMapped();
assertAllThemesMapped();
